import { render } from "./JoinTournamentModal.vue?vue&type=template&id=ef8242ea&scoped=true&ts=true"
import script from "./JoinTournamentModal.vue?vue&type=script&lang=ts"
export * from "./JoinTournamentModal.vue?vue&type=script&lang=ts"

import "./JoinTournamentModal.vue?vue&type=style&index=0&id=ef8242ea&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef8242ea"]])

export default __exports__